module.exports = __webpack_public_path__ + "assets/img/btn-back-49a063bd.png";